<template>
    <transition
        name="fade"
        mode="out-in">
        <div class="about-us">
            <div class="static-header">
                <h1 class="is-text-capitalized">
                    {{ $t("aboutUs.title") }}
                </h1>
            </div>
            <div class="static-page">
                <div class="team">
                    <div
                        v-for="(member, index) of theTeam"
                        :key="index"
                        class="team-member is-centered">
                        <figure>
                            <img
                                :src="require('../static/img/aboutus/' + member.img)"
                                :alt="member.name" />
                        </figure>
                        <p class="is-text-semi is-color-white">
                            {{ member.name }}
                        </p>
                        <p>{{ member.role }}</p>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    layout: 'home',
    transition: {
        name: 'fade',
        mode: ''
    },
    computed: {
        theTeam () {
            return [
                {
                    img: '001.png',
                    name: 'Arthur Madrid',
                    role: 'CEO'
                },
                {
                    img: '002.png',
                    name: 'Sebastien Borget',
                    role: 'COO'
                },
                {
                    img: '003.png',
                    name: 'Marcelo Santurio',
                    role: 'CFO'
                },
                {
                    img: '004.png',
                    name: 'Lucas Shrewsbury',
                    role: 'CTO'
                },
                {
                    img: '005.png',
                    name: 'Damian Volantino',
                    role: 'Head of Design'
                },
                {
                    img: '006.png',
                    name: 'Thibault Simar',
                    role: 'Head of Art'
                },
                {
                    img: '007.png',
                    name: 'Marcus Bläsche',
                    role: 'Head of Marketing'
                },
                {
                    img: '008.png',
                    name: 'Pablo Iglesias',
                    role: 'Lead VoxEdit Developer'
                },
                {
                    img: '009.png',
                    name: 'Julio Ibarguren',
                    role: 'Lead Web Developer'
                },
                {
                    img: '010.png',
                    name: 'Alejandro Andes',
                    role: 'Lead Game Developer'
                },
                {
                    img: '011.png',
                    name: 'Louis-Ambroise Van Hullebusch',
                    role: 'Lead Game Designer'
                },
                {
                    img: '012.png',
                    name: 'Ronan Sandford',
                    role: 'Lead Blockchain Architect'
                },
                {
                    img: '013.png',
                    name: 'Jean-Etienne Martin',
                    role: 'Game Project Manager'
                },
                {
                    img: '014.png',
                    name: 'Erika Del Pozo Ebert',
                    role: 'UX/UI Designer'
                },
                {
                    img: '015.png',
                    name: 'Rodrigo Herrero',
                    role: 'Community Manager'
                },
                {
                    img: 'Aminata.png',
                    name: 'Aminata Cisse',
                    role: 'Community Manager'
                },
                {
                    img: '016.png',
                    name: 'Yohan Lee',
                    role: 'Community Manager'
                },
                {
                    img: '017.png',
                    name: 'Yael Kryza',
                    role: 'Quality Assurance'
                },
                {
                    img: '018.png',
                    name: 'Joel Crespo',
                    role: 'Frontend Developer'
                },
                {
                    img: '019.png',
                    name: 'León Isla',
                    role: 'Backend Developer'
                },
                {
                    img: '022.png',
                    name: 'Maximiliano Moretti',
                    role: 'DevOps'
                },
                {
                    img: 'Felipe.png',
                    name: 'Felipe Nuñez',
                    role: 'Game Designer'
                },
                {
                    img: 'tozy.png',
                    name: 'Manuel Tozy Carazo',
                    role: 'Game Designer'
                },
                {
                    img: '024.png',
                    name: 'Joel Kaltman',
                    role: 'Game Developer'
                },
                {
                    img: 'eliseo.png',
                    name: 'Eliseo Viola',
                    role: 'Game Developer'
                },
                {
                    img: '025.png',
                    name: 'Walter Mito',
                    role: 'Game Developer'
                },
                {
                    img: '026.png',
                    name: 'Emilio Dazza',
                    role: 'Game Developer'
                },
                {
                    img: '027.png',
                    name: 'Matias Jaureguiberry',
                    role: 'Game Developer'
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.about-us {
  background-color: $grey-15;
  .static-header {
    padding: 100px 0 40px 0;
    margin-bottom: 0;
    @include breakpoint($device: mobile) {
        padding: 80px 0 40px 0;
    }
    h1 {
        font-size: 50px;
        font-weight: Bold;
        text-transform: uppercase;
        margin: 0px 20px;
        @include breakpoint($device: touch) {
            font-size: 25px;
        }
    }
  }
  .static-page {
    padding-top: 0;
    padding: 7px 7px;
    max-width: 1210px;
    margin: 0 auto;
    padding-bottom: 50px;
  }
}

.fade-enter-active {
  transition: all 1s;
}

.fade-enter,
.fade-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.team {
  @include flex(row, center, center);
  flex-wrap: wrap;
  .team-member {
    width: 189px;
    margin: 0 25px 50px;
    text-align: center;
    figure {
      margin: 0 auto 10px auto;
      width: 140px;
      height: 140px;
      img {
          width: 100%;
      }
    }
    p {
        margin: 0;
        &:first-of-type {
            font-weight: 600;
        }
    }
  }
  @include breakpoint($device: mobile) {
    margin-top: 10px;
    .team-member {
      width: 133px;
      margin: 0 10px 50px;
      figure {
        width: 110px;
        height: 110px;
      }
    }
  }
}
</style>
